import React, { memo } from 'react'
import './index.scss'

interface PaneTitleProps {
  title: string
}

function PaneTitle(props: PaneTitleProps) {
  return <div className='cmp-pane-title'>
    <span>{props.title}</span>
  </div>
}

export default memo(PaneTitle)